import { Component, Vue } from 'vue-property-decorator'

import VacationContent from './VacationContent/index.vue'
import MyTasks from './MyTasks/index.vue'

@Component({
	components: {
		MyTasks,
		VacationContent,
	},
})
export default class HomeColaborator extends Vue {
	get userFirstName() {
		return JSON.parse(localStorage.getItem('user')!).name.split(' ')[0]
	}
}
